import { useCallback, useRef, useState } from "react";
import { FaUserCog } from "react-icons/fa";
import { GoChevronDown } from "react-icons/go";

import { signOut } from "@Firebase/firebase";
import { formatFirstAndLastNames } from "@Utils/functions";

import IconButton from "@Components/IconButton";

import useOnClickOutside from "@Hooks/useClickOutside";
import useCurrentUser from "@Hooks/useCurrentUser";
import TermsAndConditionsDialog from "@Pages/TermsAndConditions/TermsAndConditionsDialog";
import styles from "./UserMenu.module.scss";
import { toast } from "react-toastify";
import { usePasswordReset } from "@Hooks/usePasswordReset";

const UserMenu = () => {
  const [open, setOpen] = useState(false);
  const [termsAndConditionsOpen, setTermsAndConditionsOpen] = useState(false);
  const user = useCurrentUser();
  const handleOpen = () => setOpen(!open);
  const passwordResetCallback = () => {
    toast.info(
      "Password reset link sent! Please, check your email to complete the update password process.",
      {
        position: "top-center",
      }
    );
    setOpen(false);
  };
  const { sendPasswordResetEmail } = usePasswordReset(passwordResetCallback);

  const ref = useRef<HTMLDivElement | null>(null);
  const closeFnCallback = useCallback(() => () => setOpen(false), [ref]);
  useOnClickOutside(ref, closeFnCallback);

  const handleChangePassword = () => {
    if (user?.data.info.email) {
      sendPasswordResetEmail({ email: user?.data?.info?.email });
    }
  };
  const handleShowTermsAndConditions = () =>
    setTermsAndConditionsOpen(!termsAndConditionsOpen);

  return (
    <div className={styles.container} data-testid={"user-menu"}>
      <FaUserCog size={30} color="#6B97F6" />

      <span className={styles.name}>
        {user?.data?.info?.firstName || user?.data?.info?.lastName
          ? formatFirstAndLastNames(
              user?.data?.info?.firstName,
              user?.data?.info?.lastName
            )
          : user?.data.info.email}
      </span>
      <IconButton dataTestId="user-menu-open-button" onClick={handleOpen}>
        <GoChevronDown />
      </IconButton>
      {open && (
        <div
          data-testid={"user-menu-content"}
          ref={ref}
          className={styles.userMenu}
          id="user-menu"
        >
          <div className={styles.userMenuItem} onClick={() => signOut(user)}>
            Sign out
          </div>

          <div
            data-testid={"change-password-button"}
            className={styles.userMenuItem}
            onClick={handleChangePassword}
          >
            Change Password
          </div>
          <div
            data-testid={"terms-and-conditions"}
            className={styles.userMenuItem}
            onClick={handleShowTermsAndConditions}
          >
            Terms And Conditions
          </div>
        </div>
      )}
      <TermsAndConditionsDialog
        open={termsAndConditionsOpen}
        setOpen={setTermsAndConditionsOpen}
      />
    </div>
  );
};

export default UserMenu;
